<template>
	<div
		:id="uid"
		:class="['transactions-card', hasErrorTransactions && 'has-error']"
	>
		<div class="transactions-card__status">
			<NotificationIcon
				:variant="notificationVariantIcon"
				ref="tooltipStatusRef"
				@mouseenter="tooltipStatusVisible = true"
				@focus="tooltipStatusVisible = true"
				@mouseleave="tooltipStatusVisible = false"
				@blur="tooltipStatusVisible = false"
			/>
			<Tooltip
				:text="transaction.health"
				:trackedRefName="'tooltipStatusRef'"
				:display="tooltipStatusVisible"
				:offset="[4, 4]"
				position="top-start"
			/>
		</div>

		<div class="transactions-card__main">
			<div class="transactions-card__heading">
				<div class="transactions-card__heading-group">
					<Ellipsis
						:timeout="3000"
						class="transactions-card__heading-type"
						:data="transaction.logTypeFormated"
					></Ellipsis>

					<div class="transactions-card__heading-integrator">
						<!-- <a
							class="link"
							@click.prevent="routePathVendorDetail"
							data-test="detailLink"
							>{{
								transaction.integratorName ||
									transaction.primaryIntegrationVendor
							}}</a
						> -->
						{{ integratorName }}
					</div>
					<Ellipsis
						:timeout="3000"
						class="transactions-card__heading-dms-is"
						v-if="
							is3pVendorTransactionType &&
								transaction.dmsIntegrationSolution
						"
						:data="transaction.dmsIntegrationSolution"
					></Ellipsis>
					<Ellipsis
						:timeout="3000"
						class="transactions-card__heading-manufacturer"
						:data="transaction.oemManufacturer"
					></Ellipsis>
				</div>
				<div class="transactions-card__heading-timestamp">
					<span class="transactions-card__heading-timestamp-date">{{
						shortDateString(transaction.timestamp)
					}}</span>
					<span class="transactions-card__heading-timestamp-time">
						{{ timeAndTimeZone(transaction.timestamp) }}
					</span>
				</div>
			</div>

			<ul class="transactions-card__details">
				<li class="transactions-card__details-item">
					<span class="transactions-card__details-label"
						>Transaction ID:</span
					>
					<Ellipsis
						:timeout="3000"
						class="transactions-card__details-txt"
						:data="transaction.transactionId"
					></Ellipsis>
				</li>

				<li class="transactions-card__details-item">
					<span class="transactions-card__details-label"
						>Correlation ID:</span
					>
					<Ellipsis
						:timeout="3000"
						class="transactions-card__details-txt"
						:data="transaction.correlationId"
					></Ellipsis>
				</li>

				<li class="transactions-card__details-item">
					<span class="transactions-card__details-label"
						>Client:</span
					>
					<Ellipsis
						:timeout="3000"
						class="transactions-card__details-txt"
						:data="customerName"
					></Ellipsis>
				</li>

				<li class="transactions-card__details-item">
					<span class="transactions-card__details-label"
						>Company:</span
					>
					<Ellipsis
						:timeout="3000"
						class="transactions-card__details-txt"
						:data="transaction.companyName"
					></Ellipsis>
				</li>

				<!-- DEV NOTE: "Integration" data should be shown on both 3P Vendor and OEM transaction types -->
				<li class="transactions-card__details-item">
					<span class="transactions-card__details-label"
						>Integration:</span
					>
					<Ellipsis
						:timeout="3000"
						class="transactions-card__details-txt"
						:data="transaction.integrationName"
					></Ellipsis>
				</li>

				<!-- DEV NOTE: "Method" data should be shown on both 3P Vendor and OEM transaction types -->
				<!-- <li
					class="transactions-card__details-item"
					v-if="
						is3pVendorTransactionType &&
							transaction.transactionMethod
					"
				> -->
				<!-- <li class="transactions-card__details-item">
					<span class="transactions-card__details-label"
						>Method:</span
					>
					<Ellipsis
						class="transactions-card__details-txt"
						:data="transaction.transactionMethod"
					></Ellipsis>
				</li> -->

				<li class="transactions-card__details-item">
					<span class="transactions-card__details-label"
						>Method:</span
					>
					<Ellipsis
						class="transactions-card__details-txt"
						:data="
							transaction.thirdPartyVendorMethod ||
								transaction.oemMethod
						"
					></Ellipsis>
				</li>
				<!-- DEV NOTE: "Direction" data should be shown on both 3P Vendor and OEM transaction types -->
				<!-- <li
					class="transactions-card__details-item"
					v-if="!isOtherTransactionType && transaction.direction"
				> -->
				<li class="transactions-card__details-item">
					<span class="transactions-card__details-label"
						>Direction:</span
					>
					<Ellipsis
						class="transactions-card__details-txt"
						:data="transaction.direction"
					></Ellipsis>
				</li>

				<li class="transactions-card__details-item">
					<span class="transactions-card__details-label">API: </span>
					<Ellipsis
						class="transactions-card__details-txt"
						:data="getApiTypeAndVersion"
					/>
				</li>
			</ul>

			<div class="transactions-card__tags">
				<TagLabel
					message="DMS Integration Solution"
					data-testid="withDependents"
					v-if="showDMSISTagLabel"
				/>
				<TagLabel
					:message="`Uses ${transaction.aggregatorIntegratorName}`"
					:state="'secondary-2'"
					data-testid="displayIfDMSIS"
					v-if="showUsesTagLabel"
				/>
				<TagLabel
					message="Direct"
					:state="'secondary-1'"
					data-testid="displayIfDirect"
					v-if="showDirectTagLabel"
				/>
			</div>
		</div>

		<ActionsSet
			:id="`${uid}_action`"
			:variant="variant"
			:options="actions"
			class="transactions-card__actions"
		/>
	</div>
</template>

<script>
import ActionsSet from '@/site-components/actions-set/actions-set';
import TagLabel from '@/components/visual/tag-label';
import Ellipsis from '@/components/visual/ellipsis';
import DatetimeMixin from '@/mixins/datetime-mixin';
import { GET_CUSTOMER_OPTION_NAME } from '@/sections/options/options-mutation-type';
import CustomerOptions from '@/mixins/customers/customer-options';
import NotificationIcon from '@/components/notifications/notification-icon/notification-icon';
import Tooltip from '@/components/shells/tooltip/tooltip';
//const
import {
	logEntrytransactionTypes,
	Healths
} from '@/sections/transactions/shared/transactions-filters-params';

export default {
	name: 'GlobalTransactionsCard',
	mixins: [DatetimeMixin, CustomerOptions],
	components: {
		ActionsSet,
		TagLabel,
		Ellipsis,
		NotificationIcon,
		Tooltip
	},
	props: {
		transaction: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			companyOptions: [],
			tooltipStatusVisible: false
		};
	},
	computed: {
		customerName() {
			return (
				this.transaction.dealershipGroupName ||
				this.transaction.customerName ||
				this[GET_CUSTOMER_OPTION_NAME](this.transaction.customerId)
			);
		},

		is3pVendorTransactionType() {
			return (
				this.transaction.logTypeFormated ==
				logEntrytransactionTypes.ThirdPartyVendor
			);
		},
		isOEMTransactionType() {
			return (
				this.transaction.logTypeFormated == logEntrytransactionTypes.Oem
			);
		},
		isOtherTransactionType() {
			return (
				this.transaction.logTypeFormated ==
				logEntrytransactionTypes.Other
			);
		},
		actions() {
			let actions = [
				// DEV NOTE: "Integration" action button should be shown on both 3P Vendor and OEM transaction types -->
				{
					disabled: true, //Dev: After Product confirm this action make it true
					iconClass: 'icon icon-customer-integration',
					label: 'Integration',
					type: 'anchor',
					visible: true
				}
			];
			if (this.transaction.logType === 'SecureVueLogEntry') {
				actions.unshift({
					action: this.routePathDetails,
					disabled: false,
					iconClass: 'icon icon-document',
					label: 'Details',
					type: 'anchor',
					visible: true
				});
			}
			return actions.map((action, index) => ({
				id: index + 1,
				...action
			}));
		},
		isMobile() {
			return this.screenSize.mobile;
		},
		notificationVariantIcon() {
			const healthVariants = {
				Success: 'positive',
				Error: 'negative'
			};
			return healthVariants[this.transaction.health] || 'warning';
		},
		hasErrorTransactions() {
			return this.transaction.health === Healths.Error;
		},
		showDirectTagLabel() {
			return !this.transaction.aggregatorIntegratorName;
		},
		showUsesTagLabel() {
			return (
				this.transaction.aggregatorIntegratorName &&
				this.transaction.aggregatorIntegratorName !== 'SIS'
			);
		},
		showDMSISTagLabel() {
			return (
				this.transaction.dmsis &&
				this.transaction.aggregatorIntegratorName == 'SIS'
			);
		},
		integratorName() {
			const integratorName =
				this.transaction.integratorName ||
				this.transaction.primaryIntegrationVendor;

			const integratorNameSplitted = integratorName.split('-');
			if (
				integratorNameSplitted.length > 1 &&
				integratorNameSplitted[0].toLowerCase().includes('motive')
			) {
				return integratorNameSplitted[1].trim();
			}
			return integratorName;
		},
		getApiTypeAndVersion(){
			return `${this.transaction.apiType}| ${this.transaction.apiVersion}`;
		}
	},
	methods: {
		routePathDetails() {
			this.$router.push({
				name: 'global-transactions-settings',
				params: {
					transactionId: this.transaction.transactionId,
					health: Healths[this.transaction.health]
				}
			});
		},
		routePathVendorDetail() {
			this.$router.push({
				name: 'vendors-settings',
				params: {
					id: 209 //Dev: change this number by real transaction.vendorId getting from the GTV log
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
/**
	* Global Transaction Viewer Card
**/

@import '@/scss/5-objects/_cards.scss';

.transactions-card {
	@include card;
	display: grid;
	grid-template-columns: auto 1fr;
	column-gap: $gutter-lg;
	row-gap: $gutter-md;
	align-items: start;
	font-size: $default-font-size - 2;

	&.has-error {
		@include card('error');
	}

	&__status {
		position: relative;
		@include vertical-horizontal-center-with-flex;
		z-index: 1;
		cursor: default;
	}

	&__heading {
		display: grid;
		grid-template-columns: 1fr auto;
		gap: $gutter-xl;
	}

	&__heading-group {
		min-width: 0;
		min-height: 44px;
		display: flex;
		flex-direction: column;
		gap: $gutter-xs;
	}

	&__heading-type {
		cursor: default;
		@include heading('md');
		text-transform: capitalize;
	}

	&__heading-integrator {
		@include ellipsis;
	}

	&__heading-manufacturer,
	&__heading-dms-is {
		@include body-text('regular');
	}

	&__heading-timestamp {
		display: flex;
		flex-direction: column;
		gap: $gutter-xs;
		@include body-text('sm');
		text-align: right;
	}

	&__details {
		display: grid;
		grid-auto-flow: column;
		grid-template-columns: repeat(auto-fit, 1fr);
		grid-template-rows: repeat(4, 1fr);
		column-gap: $gutter-xl;
		row-gap: $gutter-md;
		margin-top: $gutter-lg;
	}

	&__details-item {
		@include body-text('sm');
		display: grid;
		grid-template-columns: auto 1fr;
		column-gap: $gutter-sm;
	}

	&__details-label {
		color: $neutral-2;
	}

	&__tags {
		display: flex;
		flex-wrap: wrap;
		gap: $gutter-md;
		margin-top: $gutter-lg;
		margin-bottom: $gutter-md;
	}

	&__actions {
		grid-column: 2/3;
		align-self: flex-end;
		display: flex;
		flex-direction: column;
	}
}
</style>
